import { render, staticRenderFns } from "./PricesListCard.vue?vue&type=template&id=0988e545&scoped=true&"
import script from "./PricesListCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesListCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricesListCard.vue?vue&type=style&index=0&id=0988e545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988e545",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0988e545')) {
      api.createRecord('0988e545', component.options)
    } else {
      api.reload('0988e545', component.options)
    }
    module.hot.accept("./PricesListCard.vue?vue&type=template&id=0988e545&scoped=true&", function () {
      api.rerender('0988e545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesListCard.vue"
export default component.exports